"use strict";
exports.__esModule = true;
exports.getSelectedOptionLabels = void 0;
var getSelectedOptionLabels = function (keys, items) {
    if (!keys || !items) {
        return [];
    }
    if (keys === "all") {
        return items.map(function (item) { return item.label; });
    }
    return Array.from(keys)
        .map(function (key) { var _a, _b; return (_b = (_a = items.find(function (item) { return item.value === key; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ""; })
        .filter(function (item) { return item !== ""; });
};
exports.getSelectedOptionLabels = getSelectedOptionLabels;
//# sourceMappingURL=getSelectedOptionLabels.js.map